export const announcements = {
    el: {
        header: 'Ανακοινώσεις',
        caption: 'Παρακολουθείστε τις Ανακοινώσεις της ομάδας μας!',
    },
    en: {
        header: 'Announcements',
        caption: 'Watch our team\'s Annoucements!',
    },
}